import { FileTree } from '@it-incubator/ui-kit'
import { EntryType, FileOrDirectory, useGetMDXFilesTreeQuery } from 'features/videos/service'

type Props = {
  selectedMdx: string
  setSelectedMdx: (s: string) => void
}

export const MdxFileSelector = ({ selectedMdx, setSelectedMdx }: Props) => {
  const { data } = useGetMDXFilesTreeQuery()

  return (
    <div>
      <FileTree>
        {data?.map(item => (
          <RenderItem
            item={item}
            key={item.path}
            onFileClick={setSelectedMdx}
            selectedItemPath={selectedMdx}
          />
        ))}
      </FileTree>
    </div>
  )
}

const shouldOpenFolder = (dirPath: string, filePath: string): boolean => {
  return filePath.startsWith(dirPath)
}

type RenderItemProps = {
  item: FileOrDirectory
  onFileClick: (path: string) => void
  selectedItemPath: string
}

const RenderItem = ({ item, onFileClick, selectedItemPath }: RenderItemProps) => {
  const isOpen = selectedItemPath ? shouldOpenFolder(item.path, selectedItemPath) : false

  if (item.type === EntryType.Directory) {
    return (
      <FileTree.Folder defaultOpen={isOpen} name={item.name}>
        {item.children &&
          item.children.map(childItem => (
            <RenderItem
              item={childItem}
              key={childItem.path}
              onFileClick={onFileClick}
              selectedItemPath={selectedItemPath}
            />
          ))}
      </FileTree.Folder>
    )
  }

  const handleFileSelected = () => {
    onFileClick(item.path)
  }

  const isSelected = selectedItemPath === item.path

  return <FileTree.File active={isSelected} name={item.name} onClick={handleFileSelected} />
}
